import * as Sentry from '@sentry/browser';

export const initializeSentry = () => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({ dsn: 'https://4ccb6881ff174be6a5f0262530c7026f@sentry.io/1507424' });
  }
};
